import { Center, Loader } from "@mantine/core";
import { useEffect, useState } from "react";
import { RoutesDispatcher } from "/@/routes/RoutesDispatcher";
import { api } from "./services/api/api";
import { useAuthContext } from "./shared/contexts/AuthContext";
import { FormsProvider } from "@jasper/forms";
import "dayjs/locale/fr";
import "@mantine/dropzone/styles.css";
import "@mantine/carousel/styles.css";
import i18n from "./i18n";
import { UseCasesProvider } from "@jasper/use-cases";
import { ProductWorkflowsProvider } from "@jasper/product-workflows";

function App() {
  const [authInit, setAuthInit] = useState(true);
  const { logIn, logOut } = useAuthContext();

  const checkIfLoggedIn = async () => {
    const user = await api.get("/users/me");
    return user;
  };

  const onFocus = () => {
    if (!checkIfLoggedIn()) {
      logOut();
    }
  };

  useEffect(() => {
    window.addEventListener("focus", onFocus);

    return () => {
      window.removeEventListener("focus", onFocus);
    };
  }, [false]);

  useEffect(() => {
    checkIfLoggedIn()
      .then(res => {
        logIn(res.data);
      })
      .catch(() => {
        logOut();
      })
      .finally(() => {
        setAuthInit(false);
      });
  }, []);

  return !authInit ? (
    <FormsProvider i18n={i18n}>
      <UseCasesProvider i18n={i18n}>
        <ProductWorkflowsProvider i18n={i18n}>
          <RoutesDispatcher />
        </ProductWorkflowsProvider>
      </UseCasesProvider>
    </FormsProvider>
  ) : (
    <Center h="100vh">
      <Loader />
    </Center>
  );
}

export default App;
